import { createGenerateClassName, createMuiTheme } from "@material-ui/core/styles";

export const generateClassName = createGenerateClassName();

export const theme = createMuiTheme({
  typography: {
    fontFamily: ['"Roboto"', "sans-serif"].join(","),
  },
  palette: {
    primary: {
      main: "#db0001",
      light: "#db0001",
      dark:'db0001'
    },
    secondary: {
      main: "#fff",
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 6,
        textTransform: "none",
        fontWeight: 600,
        padding: "8px 24px",
        margin: "4px",
        transition: "all 0.3s ease",
      },
      contained: {
        backgroundColor: "#db0001", 
        color: "#fff",
        '&:hover': {
          backgroundColor: "#a30001", 
        },
      },
      outlined: {
        backgroundColor: "#db0001", 
        color: "#fff",
        borderColor: "#db0001",
        '&:hover': {
          backgroundColor: "#a30001",
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#db0001",
        },
         "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#db0001",
      },
      },
    },
    MuiInput: {
      underline: {
        "&:hover:not(.Mui-disabled):before": {
          borderBottom: "1px solid #db0001",
        },
         "&:after": {
         borderBottom: "2px solid #db0001",
    },
      },
    },
    MuiFilledInput: {
      root: {
        "&:hover:not(.Mui-disabled):before": {
          borderBottom: "1px solid #db0001",
        },
      },
    },
    MuiFormLabel: {
    root: {
      "&.Mui-focused": {
        color: "#db0001",
      },
    },
  },
  MuiFormControl: {
    root: {
      color: '#db0001'
    }
  },
 },
});
